import {gsap} from "gsap";
import {tweens_arrays_apparition as tween_big_title} from '../../../miscellaneous/bigTitle'
window.$ = window.jQuery = require('jquery');

const animationOnce = (container) => {

    const tl = gsap.timeline({
        defaults : {
            duration: 1,
            ease: "power1.out",
        }
    });

    tl
        .to('#site-preloader img', {autoAlpha: 1})
        .to('#site-preloader', {autoAlpha: 0, ease: "power1.in"}, '+=1')
        .add(tween_big_title);
    return tl;

}

export default animationOnce;